import {Component, input, ChangeDetectionStrategy} from "@angular/core"
import {DataObjectThumbnailComponent} from "@common/components/data-object-thumbnail/data-object-thumbnail.component"
import {DownloadResolution} from "@generated"
import {ThumbnailLayout} from "@common/models/enums/thumbnail-layout"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-user-thumbnail",
    imports: [DataObjectThumbnailComponent],
    templateUrl: "./user-thumbnail.component.html",
    styleUrl: "./user-thumbnail.component.scss",
})
export class UserThumbnailComponent {
    readonly $user = input<{galleryImage?: {id: string} | null} | undefined | null>(null, {alias: "user"})
    readonly $size = input<"small" | "medium" | "100%">("small", {alias: "size"})
    readonly $rounded = input<boolean>(true, {alias: "rounded"})

    protected readonly DownloadResolution = DownloadResolution
    protected readonly ThumbnailLayout = ThumbnailLayout
}
